<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse1" aria-expanded="false" aria-controls="collapse1">
                Burgerlijke staat - Hele jaar gehuwd
            </button>
        </h2>
        <div id="collapse1" class="accordion-collapse collapse" aria-labelledby="heading1"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <b>Wanneer kiezen voor 'Hele jaar gehuwd'?</b><br/>
                De optie 'Hele jaar gehuwd' bij burgerlijke staat kies je als de belastingplichtige
                <b>heel {{ this.year }}</b>:
                <li class="list">getrouwd is</li>
                <li class="list">een geregistreerd partnerschap heeft</li>
                <li class="list">een echtscheiding of scheiding van tafel en bed heeft aangevraagd bij de rechter of al gescheiden
                    is, maar in heel {{ this.year }} nog steeds samen op hetzelfde woonadres staat
                    ingeschreven bij de gemeente
                </li>
                <li class="list">in {{ this.year }} niet meer op hetzelfde adres staat ingeschreven, maar in {{ this.year }} nog geen
                    echtscheiding of scheiding van tafel en bed heeft aangevraagd
                </li>
                <li class="list">met wederzijds goedvinden een geregistreerd partnerschap heeft beëindigd met een
                    beëindigingsovereenkomst, maar de belastingplichtige in {{ this.year }} nog steeds op hetzelfde
                    woonadres staat ingeschreven bij de gemeente
                </li>
                <li class="list">in {{ this.year }} niet meer op hetzelfde adres staat ingeschreven, maar bij beëindiging van het
                    partnerschap
                    met wederzijds goedvinden, in {{ this.year }} nog geen beëindigingsovereenkomst heeft ondertekend
                </li>
                <li class="list">heel {{ this.year }} nog steeds samen op hetzelfde woonadres staat ingeschreven bij de
                    gemeente, maar bij beëindiging van het geregistreerd partnerschap zonder wederzijds goedvinden,
                    in {{ this.year }} een verzoek bij de rechter heeft ingediend om de ontbinding uit te spreken
                </li>
                <li class="list">in {{ this.year }} niet meer op hetzelfde adres staat ingeschreven, maar bij beëindiging van het
                    partnerschap zonder wederzijds goedvinden, in {{ this.year }} nog geen ontbinding van het
                    geregistreerd partnerschap bij de rechter heeft aangevraagd.
                </li>
                <div class="space10"></div>
                <b>Wanneer is er geen sprake van een echtgenoot?</b><br/>
                Er is geen sprake van een 'echtgenoot' als de belastingplichtige:
                <li class="list">in {{ this.year }} nog wel getrouwd is, maar vóór {{ this.year }} een echtscheiding of scheiding van
                    tafel en bed heeft aangevraagd en vóór {{ this.year }} al niet meer samen op hetzelfde woonadres
                    staat ingeschreven bij de gemeente.
                </li>
                <li class="list">in {{ this.year }} nog wel geregistreerd partner was, maar vóór {{ this.year }} een
                    beëindigingsovereenkomst heeft overeengekomen of een geregistreerd partnerschap bij de rechter heeft
                    aangevraagd en vóór {{ this.year }} al niet meer samen op hetzelfde woonadres stond ingeschreven bij
                    de gemeente
                </li>
                <li class="list">de echtgenoot in {{ this.year }} buiten Nederland woont en niet kwalificerend buitenlands
                    belastingplichtig is.
                </li>
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading2">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse2" aria-expanded="false" aria-controls="collapse2">
                Burgerlijke staat - Hele jaar samenwonend
            </button>
        </h2>
        <div id="collapse2" class="accordion-collapse collapse" aria-labelledby="heading2"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <b>Wanneer kiezen voor 'Hele jaar samenwonend'?</b><br/>
                Kies deze optie als de partners in {{ this.year }} samen op hetzelfde woonadres staan ingeschreven bij de gemeente. Dit kunnen
                verschillende adressen zijn, als de partners samen verhuizen.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading3">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse3" aria-expanded="false" aria-controls="collapse3">
                Burgerlijke staat - Gewijzigd in aangiftejaar
            </button>
        </h2>
        <div id="collapse3" class="accordion-collapse collapse" aria-labelledby="heading3"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <b>Wanneer kiezen voor 'Gewijzigd in aangiftejaar?</b><br/>
                De optie 'Gewijzigd in aangiftejaar' bij burgerlijke staat kies je als de belastingplichtige:
                <li class="list">in {{ this.year }} getrouwd is of een geregistreerd partnerschap is aangegaan</li>
                <li class="list">een echtscheiding of scheiding van tafel en bed heeft aangevraagd bij de rechter of al gescheiden
                    is, maar in een deel van {{ this.year }} samen op hetzelfde woonadres staat
                    ingeschreven bij de gemeente
                </li>
                <li class="list">een deel van {{ this.year }} nog steeds samen op hetzelfde woonadres staat ingeschreven bij de
                    gemeente, maar bij beëindiging van het geregistreerd partnerschap zonder wederzijds goedvinden,
                    in {{ this.year }} een verzoek bij de rechter heeft ingediend om de ontbinding uit te spreken
                </li>
                <li class="list">
                    in {{ this.year }} een fiscaal partner had die in in {{ this.year }} overleden is
                </li>
            </div>
        </div>
    </div>

</div>

